<template>
  <div
      class="d-flex ai-center jc-between bg-white"
      :class="[ focused ? 'FOCUSED-BORDER' : 'bd-gray50' ]">
    <input
        ref="whatsNewSearchInput"
        v-model="searchText"
        aria-label="Job Search Input"
        type="text"
        class="SEARCH-INPUT input bd-transparent c-gray70"
        :placeholder="placeholderText"
        visible-placeholder
        @focus="onFocus(true)"
        @blur="onFocus(false)"
        @keydown.esc.prevent="onClear()"
        @keydown.enter.prevent="onSubmit()">
    <div class="INPUT-APPEND p-r-2:d p-r-1:mo">
      <label class="c-depot" @click="onClear()">clear</label>
    </div>
    <button
        aria-label="Search Button"
        class="SEARCH-BTN bg-depot bd-transparent d-flex jc-center ai-center"
        @click.prevent="onSubmit()">
      <vk-icon name="magnifyglass" size="20" class="c-white flex-0-0" />
    </button>
  </div>
</template>

<script>
export default {
  name: 'whats-new-search-input',
  props: {
    results: {
      type: Array,
      default: () => ([]),
    },
    value: {
      type: String,
      required: true,
    },
    placeholderText: {
      type: String,
      required: true,
    },
  },
  data () {
    return {
      searchText: '',
      focused: false,
      isClear: true,
    };
  },
  methods: {
    input () {
      this.$emit('input', this.searchText);
    },
    onSubmit () {
      this.$emit('input', this.searchText);
    },
    onFocus (isFocus) {
      this.focused = isFocus;
    },
    onClear () {
      this.searchText = '';
      this.onSubmit();
      this.$refs.whatsNewSearchInput.focus();
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@homeservices/design-kit/tools";

$size: 44px;

.SEARCH-INPUT {
  height: $size;
  width: $unit * 37.5;
  font-size: 14px;
  @include mobile-only {
    width: $unit * 30;
  }
}
::placeholder {
  color: $color-gray60;
}
.FOCUSED-BORDER {
  border: 1px solid $color-depot;
}
.SEARCH-BTN {
  width: $size;
  height: $size;

}
.ICON {
  height: inherit;
}
.INPUT-APPEND {
  & > label {
    cursor: pointer;
    user-select: none;
  }
}
</style>
